import React from 'react';
import { EntityLayout } from '@backstage/plugin-catalog';
import { RTLLinksCard } from '../../cards/LinksCard';
import { Grid } from '@material-ui/core';
import { RTLCatalogGraphCard } from '../../cards/CatalogGraphCard';
import { WarningCard } from '../../cards/WarningCard';
import {
  RELATION_API_CONSUMED_BY,
  RELATION_API_PROVIDED_BY,
  RELATION_PART_OF,
} from '@backstage/catalog-model';
import {
  EntityApiDefinitionCard,
  EntityConsumingComponentsCard,
  EntityProvidingComponentsCard,
} from '@backstage/plugin-api-docs';
import { RTLAboutCard } from '../../cards/AboutCard';

export const ApiPage = () => (
  <EntityLayout>
    <EntityLayout.Route path="/" title="Overview">
      <Grid container spacing={3} alignItems="stretch">
        <WarningCard />
        <Grid item md={6}>
          <RTLAboutCard />
        </Grid>
        <Grid item md={6} xs={12}>
          <RTLCatalogGraphCard
            height={400}
            relations={[
              RELATION_API_PROVIDED_BY,
              RELATION_API_CONSUMED_BY,
              RELATION_PART_OF,
            ]}
          />
        </Grid>
        <RTLLinksCard />
        <Grid item md={6} xs={12}>
          <EntityProvidingComponentsCard />
        </Grid>
        <Grid item md={6} xs={12}>
          <EntityConsumingComponentsCard />
        </Grid>
      </Grid>
    </EntityLayout.Route>

    <EntityLayout.Route path="/definition" title="Definition">
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <EntityApiDefinitionCard />
        </Grid>
      </Grid>
    </EntityLayout.Route>
  </EntityLayout>
);
